import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="categories"
export default class extends Controller {
  connect() {
  }

  save(e) {
    e.preventDefault()
    var item = e.currentTarget
    var data = new FormData(item);

    $.ajax({
      type: "POST",
      url: item.action,
      contentType: false,
      processData: false,
      data: data,
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function(data) {

        if(data.status == 200) {
          document.getElementById('close-modal-btn').click()
          document.getElementById('business_categories_frame').reload()
        } else {
          alert("Error saving category. Please try again.")
        }
      }
    })
  }
}
